module.exports = __webpack_public_path__ + "static/media/microsoft.f8c504c7.png";